import { useParams } from "react-router-dom";
import { useAuth } from "../../providers/authprovider";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import ProtocolForm from "./ProtocolForm";
import { v4 as uuidv4 } from "uuid";
import "./form_style.css";
import Loading from "../../components/LoadingInfo";
import useAlert from "../../components/CustomAlert";
import { useDataProvider } from "../../providers/offline_data_provider";
import { useOfflineQueue } from "../../providers/offlineQueueProvider";
import { PROTOCOL_TYPES } from "./protocolTypes";

export default function CreateProtocol(props) {
  const { copy, useCachedProtocol } = props;
  const { protocolId, protocolType: protocolTypeParam } = useParams();
  const {
    protocols: {  getProtocolById },
  } = useAuth();
  const { showAlert, hideAlert, alert } = useAlert();
  const [loading, setLoading] = useState(false);
  const [protocolType, setProtocolType] = useState("");
  const [protocol, setProtocol] = useState(undefined);
  const { protocolTemplates: templates, protocols:{getCachedProtocol} } = useDataProvider();
  const {protocols} = useOfflineQueue();

  useEffect(() => {
    if (protocolId != null) {

      if(useCachedProtocol === true) {
          const cached = protocols.find((p) => p.id === protocolId);
          if (cached) {
            setProtocol(cached.data);
            setProtocolType(cached.data.type);
            
            return;
          }
      }
      
      setLoading(true);
      getProtocolById(protocolId, ({ success, error, content }) => {

        if (!success || success === false) {
          setLoading(false);
          console.log("Trying to load protocol from cache...");
          getCachedProtocol(protocolId).then((data) => {
            console.log("Loaded protocol from cache:", data);
            if (data) {
              setProtocolType(data.type);
              setProtocol(data);
            } else {
              showAlert("danger", "Nie można załadować protokołu", 5000);
            }
          }).catch(() => {
            showAlert("danger", "Nie można załadować protokołu", 5000);
          });
          return;
        };

        if (copy === true) content.id = uuidv4();

        setProtocolType(content.type);
        setProtocol({
          id: content.id,
          date: content.date,
          building: content.building,
          version: content.version,
          elements: content.elements,
          arrival_purpose: content.arrival_purpose,
          type: content.type,
          leading_company_id: content.leading_company_id,
        });
        setLoading(false);
      });
    }
  }, [protocolId]);

  const createFromTemplate = (type) => {
    const template = templates[type];

    if (!template) {
      showAlert("danger", "Brak szablonu dla wybranego rodzaju protokołu", 5000);
      return;
    }

    const content = JSON.parse(JSON.stringify(template));

    setProtocolType(type);
    setProtocol({
      id: uuidv4(),
      version: content.version,
      elements: content.elements,
      type: type,
    });
  };

  useEffect(() => {
    if (protocolId != null || !protocolTypeParam) return;

    createFromTemplate(protocolTypeParam);
  }, [protocolId, protocolTypeParam, templates]);

  const handleSelectProtocol = ({ target }) => {
    hideAlert();
    createFromTemplate(target.value);
  };

  if (loading ) {
    return (
      <Loading show={loading === true} />
    );
  }

  return (
    <div className={"bg-light py-4 px-1 px-md-4"}>
      <div className={"container-fluid py-2 px-0 px-md-2"}>
        {!protocol && (
          <>
            <div className={"d-flex justify-content-center "}>
              <h5 className={"text-center me-4"}>Wybierz rodzaj protokołu</h5>
              <Form.Select
                size="sm"
                className={"w-25"}
                name={"form"}
                onChange={handleSelectProtocol}
                value={protocolType}
              >
                <option></option>
                {PROTOCOL_TYPES.map((t) => (
                  <option key={t.value} value={t.value}>
                    {t.label}
                  </option>
                ))}
              </Form.Select>
            </div>
          </>
        )}
        
        {alert()}
        {protocol && (
          <ProtocolForm
            protocol={protocol}
            onSave={props.onSave}
            existing={protocolId != null && copy !== true && useCachedProtocol !== true}
          />
        )}
      </div>
    </div>
  );
}
